import React from 'react';
import { modalStyles as styles } from './modalStyles';

export default function CustomerRmaModalPending({ onClose }) {
  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h2>Case Pending</h2>
        <p>Nothing happening here. Please come back later when your case has been assigned a location.</p>
        <button onClick={onClose} style={styles.button}>Close</button>
      </div>
    </div>
  );
}

